// extracted by mini-css-extract-plugin
export var box = "call-out-block-module--box--a3f51";
export var boxContainer = "call-out-block-module--boxContainer--3f0fb";
export var boxContent = "call-out-block-module--boxContent--856aa";
export var boxContentMobile = "call-out-block-module--boxContentMobile--d38bc";
export var boxDescription = "call-out-block-module--boxDescription--0cb68";
export var boxImage = "call-out-block-module--boxImage--98a4a";
export var boxImageIcon = "call-out-block-module--boxImageIcon--68e8e";
export var boxImageMobile = "call-out-block-module--boxImageMobile--557b5";
export var boxMobile = "call-out-block-module--boxMobile--1e597";
export var boxTitle = "call-out-block-module--boxTitle--829a4";